import { Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined, EyeOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';
import useWaitingLists from '../useWaitingLists';
import FormHelper from 'helpers/FormHelper';
import { Link, useLocation } from 'react-router-dom';
import UIHelper from 'helpers/UIHelper';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const {
    form,
    shops,
    inactiveShops,
    extrastockTypes,
    handleCreateOrUpdate,
    updateInProcess,
  } = useWaitingLists(false, !isNew);

  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = isNew ? t('CREARE WAITING LIST') : t('MODIFICA WAITING LIST');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            date_from: '',
            date_to: '',
            extrastock_type: '',
            manager_name: '',
            company_id: '',
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
          onFieldsChange={FormHelper.resetFormsFieldErrors(form)}
        >
          <InfoSection
            shops={shops}
            inactiveShops={inactiveShops}
            extrastockTypes={extrastockTypes}
          />
        </Form>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={onClickSave}
              width={'150px'}
              big
              icon={<CheckOutlined />}
              loading={updateInProcess}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Edit;
